<template>
	<div>


		<div
			style="width: 100%;height: 53.6rem;background-color: black;position: absolute;z-index: 1;overflow: hidden;color: white;text-align: center;">
			<el-carousel type="card" indicator-position="none" height="42rem" style="background-color: #fff; ">
				<el-carousel-item v-for="item in zmd1" :key="item" style="background-color: #fff; ">

					<el-image style="height: 42rem;background-color: #fff; " :src="item" fit="contain"
						:preview-src-list="zmd1"></el-image>

				</el-carousel-item>
			</el-carousel>
		</div>

		<div
			style="width: 100%;height: 7rem;background-color: black;position: absolute;z-index: 1;margin-top:44rem;overflow: hidden;text-align: center;">
			<div style="color: gray;float: left;margin-left: 46.5rem;margin-top: 1rem;">
				联系我们 : 0411-87588091&nbsp;0411-87588320&nbsp;13942048140&nbsp;<br>
				辽ICP备2023010852号-1
			</div>

			<div style="margin-left: 19rem; height: 7rem;width: 7rem;float: left;color: gray;">
				<img src="../assets/image/gongzhonghao.jpg" height="100%" width="100%" title="微信公众号">
			</div>
		</div>
	</div>


</template>

<script>
	export default {
		name: 'Third',
		props: {
			msg: String
		},
		data() {
			return {
				device_type: {},
				deviceKey: {
					id: "",
					name: null,
					deviceTypeId: ""
				},
				device: [],
				zmd1: [
					"http://114.116.47.165:12345/jsyyy/Snipaste_2024-10-10_16-00-25.png",
					"http://114.116.47.165:12345/jsyyy/Snipaste_2024-10-10_16-00-47.png",
					"http://114.116.47.165:12345/jsyyy/Snipaste_2024-10-10_16-00-54.png",
					"http://114.116.47.165:12345/jsyyy/Snipaste_2024-10-10_16-01-07.png",
					"http://114.116.47.165:12345/jsyyy/Snipaste_2024-10-10_16-01-17.png",
				]


			};
		},
		mounted() {
			this.http.get({
				url: "/device-type/list",
			}).then((data) => {
				this.device_type = data;
				this.deviceKey.deviceTypeId = this.device_type[0].id;
			}).then(() => {
				console.log(this.deviceKey)
				this.http.get({
					url: "/device/list",
					param: this.deviceKey,
				}).then((data) => {
					this.device = data;
				})
			})
		},
		methods: {
			handleClick(tab) {
				this.device = []
				console.log(tab.index);
				this.deviceKey.deviceTypeId = parseInt(tab.index) + 1;
				this.http.get({
					url: "/device/list",
					param: this.deviceKey,
				}).then((data) => {
					console.log(data)
					this.device = data;
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#app {
		background-color: white;
	}

	hr {
		border: 0;
		height: 0.6rem;
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(11, 11, 11, 0.75), rgba(0, 0, 0, 0));
	}

	.el-tabs__item {
		height: 4rem !important;
		line-height: 4rem !important;
	}

	.el-tabs__nav-scroll {
		overflow-y: scroll !important;
		scrollbar-width: none;
		-ms-overflow-style: none;
	}

	.el-tabs--left .el-tabs__header.is-left {
		height: 43rem !important;
		width: 22rem;
	}

	.element::-webkit-scrollbar {
		width: 0 !important
	}

	::-webkit-scrollbar {
		display: none;
	}
</style>